import { CVtemplates, Lettertemplates } from '@/constants/templates';
import { useUrl } from '@/hooks/use-url';
import Link from 'next/link';
import { useRef } from 'react';
import Slider from 'react-slick';

type Props = {
  site: any;
  type: 'CV' | 'LM';
  ctaCreateLink?: string;
  tracking_ref: string;
};

export default function ProductsSlider({ site, type = 'CV', ctaCreateLink, tracking_ref }: Props) {
  const sliderRef = useRef<Slider | null>(null);
  const { getAppUrl } = useUrl();

  const currentTemplates = type === 'CV' ? CVtemplates : Lettertemplates;

  const getImageUrl = (template: string) => {
    const folder = type === 'CV' ? 'resumes' : 'letters';
    return `https://mmc-preview-s3-storage.s3.eu-central-1.amazonaws.com/templates/${folder}/${site?.html_lang}/${template.toLowerCase()}.jpeg`;
  };

  const images = currentTemplates.map(getImageUrl);
  const imageAlt = type === 'CV' ? 'CV' : 'LM';

  const getTemplateFromUrl = (url: string) => {
    const template = url.split('/').pop()?.replace('.jpeg', '');
    return currentTemplates.find((t) => t.toLowerCase() === template);
  };

  const getCtaUrl = (templateName: string | undefined) => {
    const baseUrl =
      ctaCreateLink || getAppUrl(`/create/${type === 'CV' ? 'resume' : 'cover-letter'}?ref=${tracking_ref}`);
    return `${baseUrl}&template=${templateName}`;
  };

  return (
    <div className="relative flex flex-col items-center lg:items-end">
      <div className="my-6 flex w-full items-center justify-center gap-3 text-white md:max-w-[350px] md:pr-0 lg:mb-10 lg:mt-[-48px] lg:justify-end lg:pr-3">
        <div
          className="flex h-12 w-12 items-center justify-center rounded-full bg-white hover:cursor-pointer hover:opacity-70"
          onClick={() => sliderRef.current?.slickPrev()}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="none" viewBox="0 0 48 48">
            <path
              stroke="#4B4FF2"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
              d="M27.5 31l-7-7 7-7"
            ></path>
          </svg>
        </div>
        <div
          className="flex h-12 w-12 items-center justify-center rounded-full bg-white hover:cursor-pointer hover:opacity-70"
          onClick={() => sliderRef.current?.slickNext()}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="none" viewBox="0 0 48 48">
            <path
              stroke="#4B4FF2"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
              d="M20.5 17l7 7-7 7"
            ></path>
          </svg>
        </div>
      </div>
      <div className="slider-container relative w-full shrink-0">
        <Slider
          ref={sliderRef}
          dots={false}
          infinite={true}
          slidesToShow={1}
          slidesToScroll={1}
          centerPadding="0"
          arrows={true}
        >
          {images.map((imageUrl, i) => (
            <div className="slide !flex flex-col items-center" key={i}>
              <img src={imageUrl} alt={imageAlt} className="!border-0" width={800} height={1131} loading="lazy" />
              <div className="cta-container opacity-80">
                <Link href={getCtaUrl(getTemplateFromUrl(imageUrl))}>
                  <button className="cta small">
                    <span className="cta-text">{site.content_products_resumes.use_this_template}</span>
                    <img
                      alt="arrow right"
                      src="/assets/icons/arrow-right-white.svg"
                      width="18"
                      height="18"
                      loading="lazy"
                    />
                  </button>
                </Link>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
}
